import { Alert, Card, Space, Statistic } from 'antd'
import { format } from 'date-fns'

import type { PriceEntry } from './priceUtils'
import { monthlyFromHourly, stripTrailingZeroes } from './priceUtils'

function formatStatDate(d: string) {
  return format(new Date(d), 'MMM d, yyyy')
}

export function PriceWarnings({
  entries,
  hasIndefinite,
  overlaps,
}: {
  entries: PriceEntry[]
  hasIndefinite: boolean
  overlaps: boolean
}) {
  let active: PriceEntry | undefined
  let hasAnyCurrent = false
  for (const e of entries) {
    if (!e.expired) {
      hasAnyCurrent = true
      if (!e.activeUntil) active = e
    }
  }
  const monthly = active ? monthlyFromHourly(active.pricePerHourPerQty) : null

  return (
    <>
      {!hasAnyCurrent && entries.length > 0 && (
        <Alert
          type="warning"
          showIcon
          banner
          style={{ marginBottom: 16 }}
          message="No current price — all prices have expired."
        />
      )}
      {!hasIndefinite && entries.length > 0 && hasAnyCurrent && (
        <Alert
          type="error"
          showIcon
          banner
          style={{ marginBottom: 16 }}
          message="No indefinite price — all prices have an expiry date."
        />
      )}
      {overlaps && (
        <Alert
          type="error"
          showIcon
          banner
          style={{ marginBottom: 16 }}
          message="Price overlap detected — multiple prices are active for the same period."
        />
      )}
      {active && monthly && (
        <Card title="Current Price" size="small" style={{ marginBottom: 16 }}>
          <Space size="large">
            <Statistic
              title="Hourly"
              value={`$${stripTrailingZeroes(active.pricePerHourPerQty)}`}
            />
            <Statistic
              title="Monthly"
              value={`$${stripTrailingZeroes(monthly)}`}
            />
            <Statistic
              title="Active Since"
              value={formatStatDate(active.activeSince)}
            />
            <Statistic
              title="Active Until"
              value={
                active.activeUntil ? formatStatDate(active.activeUntil) : '∞'
              }
            />
          </Space>
        </Card>
      )}
    </>
  )
}
